import React, { useEffect, useState } from "react";
import styles from "./InnerBlog.module.css";
import BlogInfo from "../../Components/BlogInfo/BlogInfo";
import { open_api } from "../../Utils/network";
import { useParams, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

function InnerBlog() {
  const [blogData, setBlogData] = useState();
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (slug) {
      if (!isNaN(slug)) {
        open_api
          .get(`blog/blog_pages/${slug}/`)
          .then((res) => {
            if (res?.data?.meta?.slug) {
              navigate(`/blogs/${res.data.meta.slug}`, { replace: true });
            } else {
              setBlogData(res?.data);
              setIsLoading(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setIsLoading(false);
          });
      } else {
        blogDetailes(slug);
      }
    }
  }, [slug, navigate]);

  const blogDetailes = (slug) => {
    try {
      open_api
        .get(`blog/blog_pages/${slug}/`)
        .then((res) => {
          setBlogData(res?.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getBlogDetails();
  }, []);

  const getBlogDetails = () => {
    open_api
      .get(
        `blog/blog_pages?fields=id%2Ctitle%2Cpublished_date%2Cintro%2Cheader_image_url%2Ctags%2Cread_time%2Cauthors&type=blogs.BlogPage`
      )
      .then((res) => {
        if (res?.status == 200 || res?.status == 201 || res?.status == 204) {
          const items = res?.data?.data || res?.data?.items || [];
          setBlogs(Array.isArray(items) ? items : []);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const relatedBlogs = blogs.filter(
    (b) => b?.meta?.slug !== slug && b?.id !== blogData?.id
  );

  if (isLoading) {
    return (
      <div className={styles.skeletonContainer}>
        <Skeleton height={40} width="60%" />
        <div className={styles.skeletonBody}>
          <Skeleton height={20} count={5} />
          <Skeleton height={200} width="100%" style={{ marginTop: "1rem" }} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <BlogInfo data={blogData} relatedBlogs={relatedBlogs} />
    </div>
  );
}

export default InnerBlog;
